package org.lennycodes.hldi.pages
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.style.breakpoint.ResponsiveValues
import com.varabyte.kobweb.silk.style.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.dom.*
import org.lennycodes.hldi.components.CustomSection
import org.lennycodes.hldi.components.TeamCard
import org.lennycodes.hldi.components.TeamProfileDialog
import org.lennycodes.hldi.constants.HLDITheme
import org.lennycodes.hldi.data.TeamMember
import org.lennycodes.hldi.layouts.MainLayout
import org.lennycodes.hldi.styles.AboutHeroSectionStyle
import org.lennycodes.hldi.styles.AboutHeroTextStyle
import org.lennycodes.hldi.styles.AboutHeroTitleStyle
import org.lennycodes.hldi.styles.DepartmentStyle
import org.lennycodes.hldi.styles.OutlineButtonStyle
import org.lennycodes.hldi.styles.SectionWaveSvg
import org.lennycodes.hldi.styles.VolunteerButtonStyle

val leadershipTeam = listOf(
    TeamMember(
        "1",
        "Rt. Rev Severine Niwemugizi",
        "Organization Chairperson",
        "Rt. Rev. Severine Niwemugizi is the current Bishop of Rulenge–Ngara Diocese. Among his many leadership roles, he served as the President of the Tanzania Episcopal Conference (TEC) from 2000 to 2006 and later as the Chairperson of the TEC's Peace and Justice Commission from 2012 to 2018. He is a respected canonist and a distinguished advocate for sociopolitical justice and human rights.\n" +
                "\n" +
                "As the Chairperson of the organization, he leads the General Assembly, provides strategic vision and overall leadership, ensures compliance with national policies and organizational governance, and guides members through the organization's agenda, annual reports, financial reviews, and board elections.\n",
        "severine.jpeg",
        "Leadership",
        instagram = "https://www.instagram.com/severineniwemugizi/",
        email = "info@rulengengaradiocese.or.tz",
      isLeadership =   true
    ),
    TeamMember(
        "2",
        "Rev Godfrey Baraka Rusasa",
        "Executive Secretary",
        "He serves as the Executive Secretary to the Board and General Meetings, overseeing the day-to-day operations of RN-HLDI while ensuring compliance with governance, statutory, and donor requirements. A teacher, counsellor, and social worker, he brings extensive national and international experience, providing effective leadership and a strong commitment to organizational excellence and community development.",
        "rusasa.png",
        "Leadership",
        email = "godfrey.rusasa@rn-hldi.or.tz",
        instagram = "https://www.instagram.com/barakarusasa/",
      isLeadership =   true
    ),
    TeamMember(
        "3",
        "Sr. Leocardia Bernado",
        "Board Chairperson",
         "She serves as the Chairperson of the Board, providing strategic leadership and governance to the organization. She leads the Board of Directors in ensuring legal and regulatory compliance, overseeing financial management, evaluating executive performance, and guiding the organization in fulfilling its core mission and long-term vision.\n",
        "leocadia.webp",
        "Leadership",
       isLeadership =  true
    ),
    TeamMember(
        "4",
        "Mr. Manase King (Esq)",
        "Assistant Executive Secretary",
         "He is a senior legal practitioner in Tanzania, a member of the Tanganyika Law Society and the East African Law Society. As the Assistant Executive Secretary and Head of the Civic Education and Good Governance Department at RN-HLDI, he provides legal and governance oversight, safeguards the organization’s operations, and ensures compliance across all activities. He brings extensive experience in court litigation, advocacy and lobbying, policy dialogue, project proposal development, and results-based project management.\n",
        "manase.jpg",
        "Civic Education and Good Governance Department",
        instagram = "https://www.instagram.com/manase_king_esq/",
        email = "manase.king@rn-hldi.or.tz",
      isLeadership =   true
    ),
    TeamMember(
        "5",
        "Mr. Godson Charugamba",
        "Accountant",
        "He is a degree-holder and motivated accountant with strong expertise in accounting, financial management, and professional growth. He is resourceful, innovative, and flexible, with extensive experience in planning, budgeting, performance monitoring, financial statement preparation, and accounting software installation and usage.\n" +
                "\n" +
                "He has served as the Organizational Accountant for the past twelve years, managing financial stewardship and accountability while ensuring resources are utilized transparently and effectively in support of HLDI’s core mission.\n",
        "charugamba.png",
        "Leadership",
        instagram = "https://www.instagram.com/godson_charu/",
        email ="godson.charugamba@rn-hldi.or.tz",
        isLeadership = true
    ),
    TeamMember(
        "6",
        "Ms. Esther Magambo",
        "Office Administrator & Clerk",
        "She serves as the Office Administrator and Clerk to the Board and General Meetings, providing essential administrative coordination and ensuring smooth, organized, and responsive day-to-day office operations. She supports effective communication, documentation, and the overall efficiency of the organization’s administrative functions.\n",
        "magambo.webp",
        "Leadership",
        email = "esther.magambo@rn-hldi.or.tz",
       isLeadership =  true
    ),
    TeamMember(
        "7",
        "Mr. Athanas Kiyumbi",
        "Staff",
       "He is experienced in project proposal development, strategic planning, results-based project management, and partnership building across food security, sustainable livelihoods, climate resilience, and child protection initiatives. As an advocate for child safeguarding and an active member of the Biharamulo District Feeding Programme, he is dedicated to promoting sustainable and inclusive community development. Through his experience and commitment, he currently manages the Food Security and Livelihood Resilience Project.\n",
        "kiyumbi.png",
        "Food Security Department",
        email = "athanas.kiyumbi@rn-hldi.or.tz",
       isLeadership =  true
    ),
    TeamMember(
        "8",
        "Ms. Mastidia Richard",
        "Staff",
        "Manages administrative coordination across the organization — from scheduling and correspondence to records management — keeping office operations organized, responsive, and running efficiently.",
        "mastidia.webp",
        "Leadership",
        email = "mastidia.richard@rn-hldi.or.tz",
        isLeadership = true
    ),
)
val departments = listOf(
    "Food Security Department" to (
            "🌾" to "Promotes food security through emergency relief, sustainable agriculture, nutrition education, livelihood support, market access, vulnerability assessments, and advocacy for the rights of vulnerable communities."
            ),

    "Civic Education and Good Governance Department" to (
            "🏛️" to "Empowers citizens through awareness of rights and responsibilities, promotes accountability, transparency, civic participation, conflict resolution, and stronger democratic governance systems."
            ),

    "Gender, Child Protection and Safeguarding Department" to (
            "🛡️" to "Protects vulnerable groups by promoting gender equality, preventing violence and exploitation, strengthening child protection systems, supporting survivors, and ensuring safe organizational practices."
            ),

    "Environmental Conservation and Restoration Department" to (
            "🌍" to "Leads environmental protection through reforestation, ecosystem restoration, biodiversity conservation, climate resilience, community training, environmental awareness, and policy advocacy."
            ),

    "Social Services and WASH Department" to (
            "💧" to "Improves community well-being through case management, psychosocial support, child protection, water supply systems, sanitation facilities, hygiene promotion, and disease prevention."
            ),

    "MEAL and Resource Mobilization Department" to (
            "📊" to "Strengthens organizational impact through monitoring, evaluation, accountability, learning, fundraising, proposal development, donor relations, and sustainability planning."
            )
)
val volunteers = listOf(
    TeamMember(
        "9",
        "Leonard Mushumbusi",
        "Digital Communications Officer",
        "Responsible for managing the organization’s website, social media platforms, and digital communication systems to ensure effective online presence and engagement.",
        "fourteen.png",
        "Volunteers",
        isLeadership = false,
        isVolunteer = true
    ))

@Composable
@Page("/team")
fun TeamPage() {
    var selectedMember by remember {
        mutableStateOf<TeamMember?>(null)
    }
    selectedMember?.let { member ->

        TeamProfileDialog(
            member = member,
            onDismiss = {
                selectedMember = null
            }
        )

    }
    MainLayout {
        // Hero Section
        Section(
            attrs = Modifier.padding(50.px, 20.px).then( AboutHeroSectionStyle.toModifier())
                .toAttrs()
        ) {
            H1(attrs = AboutHeroTitleStyle.toAttrs()) {
                Text("Our People, Our Strength")
            }
            P(
                attrs = AboutHeroTextStyle.toAttrs {
                    style { maxWidth(700.px) } // wider than the shared 600px default for this section's longer copy
                }
            ) {
                Text("Meet the dedicated team of professionals and volunteers working tirelessly to protect lives and restore dignity across Tanzania.")
            }
            SectionWaveSvg()
        }

        // Leadership Section
        CustomSection(
            title = "Leadership Team",
            subtitle = "Our experienced leadership team guides HLDI's strategic direction and ensures excellence in all our humanitarian programs."
        ) {
            SimpleGrid(
                numColumns = ResponsiveValues(
                    1, // base (xs)
                    1, // sm
                    2, // md
                    3,  // lg+
                    3,
                    3
                ),
                modifier = Modifier.gap(32.px)
            ) {
                leadershipTeam.forEach { member ->

                    TeamCard(
                        member = member,
                        onViewProfile = {
                            selectedMember = it
                        }
                    )

                }
            }
        }

        // Departments Section
        CustomSection(
            title = "Our Departments",
            subtitle = "Specialized teams working together to deliver comprehensive humanitarian support.",
            modifier = Modifier.backgroundColor(HLDITheme.Colors.white)
        ) {
            SimpleGrid(
                numColumns = ResponsiveValues(
                    1, // base (xs)
                    1, // sm
                    2, // md
                    3,  // lg+
                    3,
                    4
                ),
                modifier = Modifier.gap(24.px)
            ) {
                departments.forEach { (name, details) ->
                    val (icon, description) = details
                    Div(
                        attrs = Modifier
                            .padding(32.px)
                            .then(
                            DepartmentStyle.toModifier()
                        ).toAttrs()


                    ) {
                        Div(
                            attrs = {
                                style {
                                    textAlign(TextAlign.Center)
                                    fontSize(40.px)
                                    marginBottom(16.px)
                                }
                            }
                        ) {
                            Text(icon)
                        }
                        H3(
                            attrs = {
                                style {
                                    textAlign(TextAlign.Center)
                                    fontSize(20.px)
                                    color(HLDITheme.Colors.primary)
                                    marginBottom(12.px)
                                    fontFamily("Playfair Display", "serif")
                                }
                            }
                        ) {
                            Text(name)
                        }
                        P(
                            attrs = {
                                style {
                                    textAlign(TextAlign.Center)
                                    fontSize(14.px)
                                    lineHeight("1.6")
                                    color(HLDITheme.Colors.mediumGray)
                                }
                            }
                        ) {
                            Text(description)
                        }
                    }
                }
            }
        }

        // Volunteers Section
        CustomSection(
            title = "Our Volunteers",
            subtitle = "Passionate individuals dedicating their time and skills to make a difference in communities across Tanzania."
        ) {
            SimpleGrid(
                numColumns = ResponsiveValues(
                    1, // base (xs)
                    1, // sm
                    2, // md
                    3,  // lg+
                    4,
                    5
                ),
                modifier = Modifier.gap(24.px)
            ) {
                volunteers.forEach { volunteer ->
                    //TeamCard(volunteer)
                }
            }
        }
        // Join CTA
        Section(
            attrs = {
                style {
                    color(HLDITheme.Colors.white)
                    textAlign(TextAlign.Center)
                    padding(80.px, 20.px)
                    borderRadius(16.px)
                    margin(60.px,32.px,32.px,32.px)
                    background("linear-gradient(135deg, ${HLDITheme.Colors.primary} 0%, ${HLDITheme.Colors.accent} 100%)")
                }
            }
        ) {
            H2(
                attrs = {
                    style {
                        fontSize(36.px)
                        fontFamily("Playfair Display", "serif")
                        marginBottom(16.px)
                    }
                }
            ) {
                Text("Become Part of the Mission")
            }
            P(
                attrs = {
                    style {
                        fontSize(18.px)
                        marginBottom(32.px)
                        opacity(0.95)
                        maxWidth(600.px)
                        marginLeft(autoLength)
                        marginRight(autoLength)
                    }
                }
            ) {
                Text("Join our team of dedicated professionals and volunteers making a difference in communities across Tanzania.")
            }

            Div(
                attrs = {
                    style {
                        display(DisplayStyle.Flex)
                        gap(16.px)
                        justifyContent(JustifyContent.Center)
                        flexWrap(FlexWrap.Wrap)
                    }
                }
            ) {
                A(
                    href = "/get-involved#volunteer",
                    attrs = Modifier
                        .padding(14.px, 32.px)
                        .then( VolunteerButtonStyle.toModifier()).toAttrs()
                )
                 {
                    Text("Apply as Volunteer")
                }

                A(
                    href = "/get-involved#partnership",
                    attrs = Modifier  .padding(14.px, 32.px)
                .then(OutlineButtonStyle.toModifier()).toAttrs(),
                ) {
                    Text("Partner With Us")
                }
            }
        }
    }
}